import { createContext, SetStateAction, Dispatch } from "react";
import { APActivitiesPerProduct, SelectOption } from "../../../../../../../../../shared/interfaces";
import { StepTwoForm } from "../../../../../utils";
import { TableActivityItem } from "./StepTwoFormProvider";
import { FormInstance } from "antd";

interface StepTwoFormContextProps {

    productsList:                       Array<SelectOption>;
    isLoadingProductsList:              boolean;

    apActiviesList:                     Array<APActivitiesPerProduct>;
    apActiviesListOptions:              Array<SelectOption>;

    stepTwoForm?:                       StepTwoForm;
    setStepTwoForm:                     Dispatch<SetStateAction<StepTwoForm | undefined>>;

    isLoadingProductsInfo:              boolean;
    setIsLoadingProductsInfo:           Dispatch<SetStateAction<boolean>>;

    activities:                         Array<TableActivityItem>;
    setActivities:                      Dispatch<SetStateAction<Array<TableActivityItem>>>;

    productsSelectedHistory:            { prevValue: string, newValue: string } | undefined; 
    setProductsSelectedHistory:         Dispatch<SetStateAction<{ prevValue: string, newValue: string } | undefined>>;

    showOnChangeProductModal:           boolean;
    setShowOnChangeProductModal:        Dispatch<SetStateAction<boolean>>;

    planWaschanged:                     boolean;
    setPlanWaschanged:                  Dispatch<SetStateAction<boolean>>;

    apFormValues:                       StepTwoForm | undefined;
    setApFormValues:                    Dispatch<SetStateAction<StepTwoForm | undefined>>;

    propertyDataForm:                   FormInstance<StepTwoForm> | undefined;

    //* Methods

    getAPActiviesListPerProduct:        ( article: string, branch: string, product: string ) => Promise<void>;
    
    loadActivitiesTableFormInfo:        ( product: string ) => Promise<void>;

    checkProductChange:                 ( value: string, prevValue: string ) => void;  

    getProducsList:                     () => Promise<void>;

    getActivityDescriptionById:         (id: string) => string | undefined;
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);